<template>
	<el-popover
		placement="right-start"
		title=""
		width="96"
		trigger="hover"
		popper-class="search-record-operate-popover"
		:append-to-body="true"
	>
		<slot slot="reference"></slot>
		<ul class="search-record-operate-ul">
			<li @click="handleRename" class="search-record-operate-li">重命名</li>
			<li @click="handleDelete" class="search-record-operate-li">删除</li>
		</ul>
	</el-popover>
</template>

<script>
export default {
	name: 'records-operate-popover',
	data() {
		return {
      
		}
	},
  methods: {
    handleRename() {
      this.$emit('rename');
    },
    handleDelete() {
      this.$emit('delete');
    }
  }
}
</script>

<style lang="scss">
.search-record-operate-popover {
  padding: 8px;
  // width: 96px !important;
  min-width: auto;
  .search-record-operate-ul {
    width: 96px;
    .search-record-operate-li {
      height: 32px;
      text-align: center;
      user-select: none;
      cursor: pointer;
      line-height: 32px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181A;
      letter-spacing: 0;
      margin-bottom: 4px;
      &:hover {
        background: #F5F7FA;
      }
      &:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
  }
}
</style>